import Swiper from 'swiper';


export default function initTeam(): void {
    const $teamContainer = document.querySelectorAll<HTMLElement>('.block-team');
    $teamContainer.forEach($container => {
        new Team($container);
    });
}

class Team {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    swiper: Swiper | null = null;
    mdBreakpoint: number;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = this.$el?.querySelector(".team-slider");
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));

        if (this.$slider) {
            window.addEventListener('resize', this.onWindowResize.bind(this));
            this.onWindowResize();
        }
    }

    onWindowResize(): void {
        if (this.swiper && window.innerWidth > this.mdBreakpoint) {
            this.destroySwiper();
        } else if (!this.swiper && window.innerWidth <= this.mdBreakpoint) {
            this.createSwiper();
        }
    }

    createSwiper(): void {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: false,
                allowTouchMove: true,
                grabCursor: true,
            });
        }
    }

    /**
     * Détruit le swiper
     */
    destroySwiper(): void {
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
}
